const notGtNum100 = (rule, value, callback) => {
    if (value > 100) {
        callback(new Error('不能大于100'));
    } else {
        callback();
    }
}
const notLtNum0 = (rule, value, callback) => {
    if (value < 0) {
        callback(new Error('不能小于0'));
    } else {
        callback();
    }
}
const notLtNum1 = (rule, value, callback) => {
    if (value < 1) {
        callback(new Error('不能小于1'));
    } else {
        callback();
    }
}
const notLeNum0 = (rule, value, callback) => {
    if (value <= 0) {
        callback(new Error('不能<=0'));
    } else {
        callback();
    }
}
const rangeOneHundred = (rule, value, callback) => {
    if (value < 0 || value>=100) {
        callback(new Error('需>=0 且 <100'));
    } else {
        callback();
    }
}

const oneToHundred = (rule, value, callback) => {
    if (typeof value === 'number' && !isNaN(value)) {
        if (value < 0 || value > 100) {
            callback(new Error('平台抽成比例 0 至 100 %之间'))
        } else {
            callback()
        }
    } else {
        callback(new Error('平台抽成比例必须为数字'))
    }
};

function num(rule, value, callback) {
    let reg = /^[0-9]*$/
    if (!reg.test(value)) {
        callback(new Error('电话号码只能是数字'));
    } else {
        callback()
    }
}

const checkPhone =
    [{pattern: /^1[2|3|4|5|6|7|8|9][0-9]{9}$/, message: "手机号格式不正确"}, {
        required: true,
        message: "请输入手机号"
    }];

const noPhone = [{pattern: /^1[3|4|5|6|7|8][9][0-9]{9}$/, message: "手机号格式不正确"}, {
    message: "请输入手机号"
}];
const pwdStrong = [
    {required: true, message: '请输入密码'},
    {
        pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{6,20}$/,
        message: '密码为数字，小写字母，大写字母，特殊符号 至少包含三种，长度为 6-20'
    }];
const pwd = [{required: true, message: '请输入密码'}, {min: 6, max: 20, message: '长度在6到20个字符'}];

const floatNumber = (rule, value, callback) => {
    let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
    if (value === '') {
        callback(new Error('请输入内容'));
    } else if (!reg.test(value)) {
        callback(new Error('请输入数字'));
    } else {
        callback();
    }
};

const moneyNumber = (rule, value, callback) => {
    let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
    if (value === '') {
        callback(new Error('请输入金额'));
    } else if (!reg.test(value)) {
        callback(new Error('请输入数字'));
    } else if (Number(value) <= 0) {
        callback(new Error('金额必须大于0'))
    } else {
        callback();
    }
};

function endPower(rule, value, callback) {
    let index = rule.field.replace(/[^0-9]/ig, "");
    let start = this.params.monthlyInfoList[index].startPower;
    if (value <= start) {
        callback(new Error('结束瓦数小于开始瓦数'))
    } else {
        callback()
    }
}

const noZero = (rule, value, callback) => {
    if (typeof value === 'number' && !isNaN(value)) {
        if (value <= 0) {
            callback(new Error('数字必须大于0'))
        } else {
            callback()
        }
    }
};
export {
    notGtNum100,
    notLtNum0,
    notLtNum1,
    notLeNum0,
    rangeOneHundred,
    noZero,
    num,
    endPower,
    oneToHundred,
    pwd,
    pwdStrong,
    noPhone,
    checkPhone,
    floatNumber,
    moneyNumber
}
